import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { IUser, ProgramStatusService } from '@ebb-v2/ebb-integration';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AccountsService } from './modules/registration/services/accounts/accounts.service';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    public currentUser: IUser = {} as IUser;
    
    constructor(
        private readonly router: Router,
        private readonly accountsService: AccountsService,
        private readonly programstatus: ProgramStatusService
    ) {}

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<boolean> {
        const programTypeCodeOptionSet = this.accountsService.programTypeCodeOptionSet;

        return this.programstatus.checkProgramstatus(programTypeCodeOptionSet).pipe(
            map(data => {
                if (data) {
                    return true;
                } else {
            
                    return false;
                }
            })
        );
    }
}
